module.exports = __webpack_public_path__ + "img/img11.8751ea05.jpg";